import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog-opener"
export default class extends Controller {
    static values = {
        dialogSelector: String,
        openMode: {type: String, default: 'dialog'}
    }

    connect() {
        if (!this.hasDialogSelectorValue) {
            console.error("No dialog selector specified!")
            return
        }

        this.element.addEventListener("click", e => {
            e.preventDefault()
            this._open()
        })
    }

    _open() {
        this.dialogElement = document.querySelector(this.dialogSelectorValue)
        if (!this.dialogElement) {
            console.error(`Dialog "${this.dialogSelectorValue}" not found!`)
            return
        }

        if (this.openModeValue === 'modal') {
            this.dialogElement.setAttribute('data-dialog-mode', "modal")
            this.dialogElement.dataset.dialogMode = "modal"
            this.dialogElement.showModal()
        } else {
            this.dialogElement.setAttribute('data-dialog-mode', "dialog")
            this.dialogElement.dataset.dialogMode = "dialog"
            this.dialogElement.show()
        }
    }
}
